class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    const variants = JSON.parse(this.querySelector('script').textContent);
    const selectedOptions = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => input.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
    const form = this.closest('form');

    if (!variant || !form) return;

    const idInput = form.querySelector('input[name="id"]');
    const submit = form.querySelector('[type="submit"]');
    idInput.value = variant.id;
    submit.disabled = !variant.available;
    form.dispatchEvent(new CustomEvent('variant:change'));
  }
}

customElements.define('variant-selects', VariantSelects);

document.querySelectorAll('[data-purchase-box]').forEach((box) => {
  const form = box.closest('form');
  const sellingPlan = box.querySelector('[data-selling-plan-select]');
  const oneTime = box.querySelector('[value="one_time"]');
  const subscription = box.querySelector('[value="subscription"]');
  const price = form.closest('.product-info').querySelector('[data-product-price]');
  const status = box.querySelector('[data-subscription-status]');
  const submit = form.querySelector('[type="submit"]');

  const updatePurchase = (variantChanged = false) => {
    const variant = box.querySelector(`[data-purchase-variant="${form.querySelector('[name="id"]').value}"]`);
    if (!variant) return;
    if (variantChanged) {
      const previousPlan = sellingPlan.value;
      sellingPlan.replaceChildren(variant.content.cloneNode(true));
      if (Array.from(sellingPlan.options).some((option) => option.value === previousPlan)) sellingPlan.value = previousPlan;
    }
    const requiresPlan = variant.dataset.requiresPlan === 'true';
    const hasPlans = sellingPlan.options.length > 0;
    subscription.disabled = !hasPlans;
    if (oneTime) {
      oneTime.disabled = requiresPlan;
      oneTime.closest('label').hidden = requiresPlan;
      if (!hasPlans && !requiresPlan) oneTime.checked = true;
    }
    if (requiresPlan) subscription.checked = true;
    const isSubscription = subscription.checked;
    sellingPlan.disabled = !isSubscription || !hasPlans;
    sellingPlan.required = isSubscription;
    box.querySelectorAll('[data-subscription-details]').forEach((detail) => {
      detail.hidden = !isSubscription;
    });
    submit.disabled = variant.dataset.available !== 'true' || (isSubscription && !hasPlans);
    price.innerHTML = isSubscription && hasPlans ? sellingPlan.selectedOptions[0].dataset.price : variant.dataset.price;
    status.textContent = !hasPlans ? 'Subscriptions are unavailable for this option.' : '';
  };

  box.addEventListener('change', () => updatePurchase());
  form.addEventListener('variant:change', () => updatePurchase(true));
  updatePurchase(true);
});

document.querySelectorAll('[data-cart-purchase-options]').forEach((box) => {
  box.hidden = false;
  const select = box.querySelector('[data-cart-selling-plan]');
  const status = box.querySelector('[data-cart-plan-status]');
  let savedPlan = select.value;
  select.addEventListener('change', async () => {
    const form = box.closest('form');
    const controls = Array.from(form.querySelectorAll('input, select, button'));
    const previousDisabled = controls.map((control) => control.disabled);
    const error = box.querySelector('[data-cart-plan-error]');
    const plan = select.value;
    if (plan === savedPlan) return;
    const quantity = Number(box.closest('.cart-item').querySelector('[name="updates[]"]').value);
    if (!Number.isInteger(quantity) || quantity < 0) {
      select.value = savedPlan;
      error.textContent = 'Enter a valid quantity before changing your purchase option.';
      return;
    }
    error.textContent = '';
    status.textContent = 'Updating…';
    box.setAttribute('aria-busy', 'true');
    controls.forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(box.dataset.line), quantity, selling_plan: plan ? Number(plan) : null })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your purchase option.');
      savedPlan = plan;
      status.textContent = 'Saved. Refreshing cart…';
      window.location.reload();
    } catch (failure) {
      select.value = savedPlan;
      status.textContent = '';
      box.removeAttribute('aria-busy');
      error.textContent = failure.message || 'Unable to update your purchase option. Please try again.';
      controls.forEach((control, index) => { control.disabled = previousDisabled[index]; });
    }
  });
});

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  const track = carousel.querySelector('[data-carousel-track]');
  const previous = carousel.querySelector('[data-carousel-prev]');
  const next = carousel.querySelector('[data-carousel-next]');

  if (!track || !previous || !next) return;

  const getScrollAmount = () => {
    const card = track.querySelector('.product-card');
    if (!card) return track.clientWidth;

    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const updateButtons = () => {
    const maxScroll = track.scrollWidth - track.clientWidth - 2;
    previous.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= maxScroll;
  };

  previous.addEventListener('click', () => {
    track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateButtons, { passive: true });
  window.addEventListener('resize', updateButtons);
  updateButtons();
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('.product-gallery__main-image');
  const thumbs = gallery.querySelectorAll('[data-product-gallery-thumb]');

  if (!mainImage || thumbs.length < 2) return;

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const fullImage = thumb.dataset.galleryFull;
      if (!fullImage) return;

      mainImage.src = fullImage;
      mainImage.srcset = '';
      mainImage.alt = thumb.dataset.galleryAlt || mainImage.alt;

      thumbs.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-current', 'false');
      });

      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
    });
  });
});
